import React, { useState } from "react";
import { ChromePicker } from "react-color";

import {
  Box,
  IconButton,
  InputAdornment,
  Popover,
  TextField,
} from "@material-ui/core";
import PaletteIcon from "@material-ui/icons/Palette";

import { useInput } from "react-admin";
import { ClearIcon } from "./iconography";

export const ColorInput = ({
  source,
  label = "Color",
  helperText = false,
  disableAlpha = true,
  fullWidth = true,
  variant = "outlined",
  margin = "dense",
  ...props
}) => {
  const {
    input: { value, onChange, ...inputRest },
    meta: { touched, error },
    isRequired,
  } = useInput({ source, ...props });

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (e) => {
    setAnchorEl(e.currentTarget);
    if (!value) onChange("#FFFFFF");
  };
  const handleClose = () => setAnchorEl(null);

  const hasValue = Boolean(value);

  return (
    <>
      <TextField
        {...inputRest}
        value={value || ""}
        onChange={(e) => onChange(e.target.value || null)}
        label={label}
        required={isRequired}
        error={touched && Boolean(error)}
        helperText={touched && error ? error : helperText}
        fullWidth={fullWidth}
        variant={variant}
        margin={margin}
        onClick={handleOpen}
        InputProps={{
          readOnly: true, // behaves like a picker field
          startAdornment: (
            <InputAdornment position="start">
              <Box
                style={{
                  width: 18,
                  height: 18,
                  borderRadius: 4,
                  background: value || "#ffffff",
                  border: "1px solid rgba(0,0,0,0.2)",
                }}
              />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              {hasValue && (
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    onChange(null);
                  }}
                  aria-label="Clear color"
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              )}
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpen(e);
                }}
                aria-label="Pick color"
              >
                <PaletteIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <Box p={1}>
          <ChromePicker
            disableAlpha={disableAlpha}
            color={value || ""}
            onChangeComplete={(c) => onChange(c.hex)}
          />
        </Box>
      </Popover>
    </>
  );
};
